/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as CdpPageView from 'src/components/CdpPageView';
import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as Container from 'src/components/Container';
import * as ContentBlock from 'src/components/ContentBlock';
import * as CustomDomScripts from 'src/components/CustomDomScripts';
import * as FEAASScripts from 'src/components/FEAASScripts';
import * as Image from 'src/components/Image';
import * as LinkList from 'src/components/LinkList';
import * as Navigation from 'src/components/Navigation';
import * as PageContent from 'src/components/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as Promo from 'src/components/Promo';
import * as RichText from 'src/components/RichText';
import * as RowSplitter from 'src/components/RowSplitter';
import * as ScrollToTopOnBack from 'src/components/ScrollToTopOnBack';
import * as Title from 'src/components/Title';
import * as Alert from 'src/components/authorable/shared/content/Alert';
import * as AppointmentModal from 'src/components/authorable/shared/content/AppointmentModal';
import * as AuthorCard from 'src/components/authorable/shared/content/AuthorCard';
import * as BlogDetailHeader from 'src/components/authorable/shared/content/BlogDetailHeader';
import * as BlogResources from 'src/components/authorable/shared/content/BlogResources';
import * as BlogTags from 'src/components/authorable/shared/content/BlogTags';
import * as ConditionHeader from 'src/components/authorable/shared/content/ConditionHeader';
import * as ContentDrivenAppointmentModal from 'src/components/authorable/shared/content/ContentDrivenAppointmentModal';
import * as EventsBanner from 'src/components/authorable/shared/content/EventsBanner';
import * as FeaturedStories from 'src/components/authorable/shared/content/FeaturedStories';
import * as GeneralHeader from 'src/components/authorable/shared/content/GeneralHeader';
import * as GlobalAlert from 'src/components/authorable/shared/content/GlobalAlert';
import * as Hero from 'src/components/authorable/shared/content/Hero';
import * as HeroHeader from 'src/components/authorable/shared/content/HeroHeader';
import * as InPageBanner from 'src/components/authorable/shared/content/InPageBanner';
import * as LocationHeader from 'src/components/authorable/shared/content/LocationHeader';
import * as Modal from 'src/components/authorable/shared/content/Modal';
import * as OfficeHours from 'src/components/authorable/shared/content/OfficeHours';
import * as ProviderHeader from 'src/components/authorable/shared/content/ProviderHeader';
import * as RTE from 'src/components/authorable/shared/content/RTE';
import * as RelatedBlogs from 'src/components/authorable/shared/content/RelatedBlogs';
import * as SocialShare from 'src/components/authorable/shared/content/SocialShare';
import * as SpecialtyHeader from 'src/components/authorable/shared/content/SpecialtyHeader';
import * as Statistics from 'src/components/authorable/shared/content/Statistics';
import * as TextLinkList from 'src/components/authorable/shared/content/TextLinkList';
import * as TextList from 'src/components/authorable/shared/content/TextList';
import * as TextMedia from 'src/components/authorable/shared/content/TextMedia';
import * as ParentChildSidegraphql from 'src/components/authorable/shared/layout/ParentChildSide.graphql';
import * as ParentChildSideNav from 'src/components/authorable/shared/layout/ParentChildSideNav';
import * as SideNavContainer from 'src/components/authorable/shared/layout/SideNavContainer';
import * as SideNavSection from 'src/components/authorable/shared/layout/SideNavSection';
import * as Accordion from 'src/components/authorable/shared/lists/Accordion';
import * as AccordionItem from 'src/components/authorable/shared/lists/AccordionItem';
import * as Carousel from 'src/components/authorable/shared/lists/Carousel';
import * as CarouselItem from 'src/components/authorable/shared/lists/CarouselItem';
import * as NavigationCardItem from 'src/components/authorable/shared/lists/NavigationCardItem';
import * as NavigationCardList from 'src/components/authorable/shared/lists/NavigationCardList';
import * as InlineVideo from 'src/components/authorable/shared/media/InlineVideo';
import * as Media from 'src/components/authorable/shared/media/Media';
import * as ButtonArray from 'src/components/authorable/shared/other/ButtonArray';
import * as CustomForm from 'src/components/authorable/shared/other/CustomForm';
import * as UserScripts from 'src/components/authorable/shared/other/UserScripts';
import * as Article from 'src/components/authorable/shared/page-specific/Article';
import * as LocationListing from 'src/components/authorable/shared/page-specific/LocationListing';
import * as OpenSchedulingWizard from 'src/components/authorable/shared/page-specific/OpenSchedulingWizard';
import * as AZConditionTreatmentSearch from 'src/components/authorable/shared/search/AZConditionTreatmentSearch';
import * as AZTeachingSheets from 'src/components/authorable/shared/search/AZTeachingSheets';
import * as BlogFacets from 'src/components/authorable/shared/search/BlogFacets';
import * as BlogSearch from 'src/components/authorable/shared/search/BlogSearch';
import * as BlogSearchHeader from 'src/components/authorable/shared/search/BlogSearchHeader';
import * as GlobalSearch from 'src/components/authorable/shared/search/GlobalSearch';
import * as LocationSearch from 'src/components/authorable/shared/search/LocationSearch';
import * as ProviderCardListing from 'src/components/authorable/shared/search/ProviderCardListing';
import * as ProviderSearch from 'src/components/authorable/shared/search/ProviderSearch';
import * as SearchforDoctorsNearYou from 'src/components/authorable/shared/search/SearchforDoctorsNearYou';
import * as Breadcrumbgraphql from 'src/components/authorable/shared/site-structure/Breadcrumb/Breadcrumb.graphql';
import * as Breadcrumb from 'src/components/authorable/shared/site-structure/Breadcrumb/Breadcrumb';
import * as Footer from 'src/components/authorable/shared/site-structure/Footer/Footer';
import * as LegalInfo from 'src/components/authorable/shared/site-structure/Footer/LegalInfo';
import * as SocialMedia from 'src/components/authorable/shared/site-structure/Footer/SocialMedia';
import * as Header from 'src/components/authorable/shared/site-structure/Header/Header';
import * as HeaderDesktop from 'src/components/authorable/shared/site-structure/Header/HeaderDesktop';
import * as HeaderMobile from 'src/components/authorable/shared/site-structure/Header/HeaderMobile';
import * as LanguageSelector from 'src/components/authorable/shared/site-structure/Header/LanguageSelector';
import * as LocationInput from 'src/components/authorable/shared/site-structure/Header/LocationInput';
import * as MinimalHeader from 'src/components/authorable/shared/site-structure/Header/MinimalHeader';
import * as SearchOverlay from 'src/components/authorable/shared/site-structure/Header/SearchOverlay';
import * as MainLayout from 'src/components/authorable/shared/site-structure/MainLayout/MainLayout';
import * as SkipNav from 'src/components/authorable/shared/site-structure/SkipNav/SkipNav';
import * as SkipToMainContentBar from 'src/components/authorable/shared/site-structure/SkipToMainContentBar/SkipToMainContentBar';

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('CdpPageView', CdpPageView);
components.set('ColumnSplitter', ColumnSplitter);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('CustomDomScripts', CustomDomScripts);
components.set('FEAASScripts', FEAASScripts);
components.set('Image', Image);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Promo', Promo);
components.set('RichText', RichText);
components.set('RowSplitter', RowSplitter);
components.set('ScrollToTopOnBack', ScrollToTopOnBack);
components.set('Title', Title);
components.set('Alert', Alert);
components.set('AppointmentModal', AppointmentModal);
components.set('AuthorCard', AuthorCard);
components.set('BlogDetailHeader', BlogDetailHeader);
components.set('BlogResources', BlogResources);
components.set('BlogTags', BlogTags);
components.set('ConditionHeader', ConditionHeader);
components.set('ContentDrivenAppointmentModal', ContentDrivenAppointmentModal);
components.set('EventsBanner', EventsBanner);
components.set('FeaturedStories', FeaturedStories);
components.set('GeneralHeader', GeneralHeader);
components.set('GlobalAlert', GlobalAlert);
components.set('Hero', Hero);
components.set('HeroHeader', HeroHeader);
components.set('InPageBanner', InPageBanner);
components.set('LocationHeader', LocationHeader);
components.set('Modal', Modal);
components.set('OfficeHours', OfficeHours);
components.set('ProviderHeader', ProviderHeader);
components.set('RTE', RTE);
components.set('RelatedBlogs', RelatedBlogs);
components.set('SocialShare', SocialShare);
components.set('SpecialtyHeader', SpecialtyHeader);
components.set('Statistics', Statistics);
components.set('TextLinkList', TextLinkList);
components.set('TextList', TextList);
components.set('TextMedia', TextMedia);
components.set('ParentChildSide.graphql', ParentChildSidegraphql);
components.set('ParentChildSideNav', ParentChildSideNav);
components.set('SideNavContainer', SideNavContainer);
components.set('SideNavSection', SideNavSection);
components.set('Accordion', Accordion);
components.set('AccordionItem', AccordionItem);
components.set('Carousel', Carousel);
components.set('CarouselItem', CarouselItem);
components.set('NavigationCardItem', NavigationCardItem);
components.set('NavigationCardList', NavigationCardList);
components.set('InlineVideo', InlineVideo);
components.set('Media', Media);
components.set('ButtonArray', ButtonArray);
components.set('CustomForm', CustomForm);
components.set('UserScripts', UserScripts);
components.set('Article', Article);
components.set('LocationListing', LocationListing);
components.set('OpenSchedulingWizard', OpenSchedulingWizard);
components.set('AZConditionTreatmentSearch', AZConditionTreatmentSearch);
components.set('AZTeachingSheets', AZTeachingSheets);
components.set('BlogFacets', BlogFacets);
components.set('BlogSearch', BlogSearch);
components.set('BlogSearchHeader', BlogSearchHeader);
components.set('GlobalSearch', GlobalSearch);
components.set('LocationSearch', LocationSearch);
components.set('ProviderCardListing', ProviderCardListing);
components.set('ProviderSearch', ProviderSearch);
components.set('SearchforDoctorsNearYou', SearchforDoctorsNearYou);
components.set('Breadcrumb.graphql', Breadcrumbgraphql);
components.set('Breadcrumb', Breadcrumb);
components.set('Footer', Footer);
components.set('LegalInfo', LegalInfo);
components.set('SocialMedia', SocialMedia);
components.set('Header', Header);
components.set('HeaderDesktop', HeaderDesktop);
components.set('HeaderMobile', HeaderMobile);
components.set('LanguageSelector', LanguageSelector);
components.set('LocationInput', LocationInput);
components.set('MinimalHeader', MinimalHeader);
components.set('SearchOverlay', SearchOverlay);
components.set('MainLayout', MainLayout);
components.set('SkipNav', SkipNav);
components.set('SkipToMainContentBar', SkipToMainContentBar);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
